import { render } from "./insurance_claims.vue?vue&type=template&id=152691e0&scoped=true"
import script from "./insurance_claims.vue?vue&type=script&lang=js"
export * from "./insurance_claims.vue?vue&type=script&lang=js"

import "./insurance_claims.vue?vue&type=style&index=0&id=152691e0&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152691e0"]])

export default __exports__